import axios from 'axios'
import { LocalStorageService } from '../services'

class TaxDataService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()

  /**
  * @author Lucia Alvarado
  * @description Handle event to create a new taxData in A3Cloud
  * @date 20-07-2020
  * @param {String} token
  * @param {Object} taxData
  * @returns {Object}
  * @memberof TaxDataService
  */
  async createTaxData(token, taxData) {
    let { clientName, rfcTaxData, email, streetTaxData, number, colonyTaxData, townshipTaxData, stateTaxData, zipCodeTaxData, personTypeId } = taxData
    email = email.toLowerCase()

    let response = await axios.post(`${this.apiUrl}/tax-data`, {
      clientName,
      rfc: rfcTaxData,
      email,
      street: streetTaxData,
      number,
      colony: colonyTaxData,
      township: townshipTaxData,
      state: stateTaxData,
      zipCode: zipCodeTaxData,
      personTypeId
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    await this.localStorageService.setLocalStorageItem('taxData', response.data.data.taxDataA3cloud.data)

    return response.data
  }


  /**
  * @author Lucia Alvarado
  * @description Handle event to create a new taxData in A3Cloud
  * @date 20-07-2020
  * @param {String} token
  * @param {Object} taxData
  * @returns {Object}
  * @memberof TaxDataService
  */
  async createTaxDataUser(taxData, token) {
    let { personTypeId, rfc, street, number, colony, township, state, zipCode, organization } = taxData

    let response = await axios.post(`${this.apiUrl}/tax-data-user`, {
      id: personTypeId,
      rfc,
      street,
      number,
      colony,
      township,
      state,
      zipCode,
      organization
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    return response.data.data
  }

  /**
 * @author Lucia Alvarado
 * @description Get tax data 
 * @date 20-07-2020
 * @param {String} token
 * @param {Object} taxData
 * @returns {Object}
 * @memberof TaxDataService
 */

  async getTaxDataByUser(token) {
    let response = await axios.get(`${this.apiUrl}/tax-data-user`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }
}

export { TaxDataService as default }
